import React, { useState, useEffect } from "react";
import translations from "./translations.json";
import MyApp from "./components/MyApp";
import Deploy from "./components/Deploy";
import Panels from "./components/Panels";
import Billing from "./components/Billing";
import Profile from "./components/Profile";
import {login} from "./apis/services";
import {register} from "./apis/services";
import "./App.css";
import Swal from 'sweetalert2';

function App() {
  const [currentLanguage, setCurrentLanguage] = useState("fa");
  const [activeTab, setActiveTab] = useState("myApp");
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login state
  const [isRegistering, setIsRegistering] = useState(true); // Track if user is registering

  console.log(localStorage.getItem("token"))

    // Use useEffect to check localStorage after the component mounts
    useEffect(() => {
  
      if (localStorage.getItem("token")) {
        setIsLoggedIn(true);
      }
    }, []); // Empty dependency array ensures this runs only once after the initial render



  const toggleLanguage = () => {
    setCurrentLanguage(currentLanguage === "en" ? "fa" : "en");
  };

  const translate = (key) => translations[currentLanguage][key];
  // Handle login submission
  const handleLogin = (email, password) => {
    // Add your login logic here (e.g., API call)
   const user = {
      EmailAddress: email,
      Password: password,
    }
    login(user)
    .then((response) => {
      if (response.status === "ok") {
        console.log('hello',response);
        localStorage.setItem("token", response.token)
        setIsLoggedIn(true); // Set logged in to true
      }else{
        Swal.fire({
          title: 'Your email or password is incorrect',
          text: 'Invalid email or password',
          icon: 'error',
          confirmButtonText: 'Ops',
        });
      }
     
    })
  };

  // Handle logout
  const handleLogout = () => {
    setIsLoggedIn(false); // Set logged in to false
    localStorage.removeItem("token")
  };

    // Handle register submission
    const handleRegister = (email, password, name, familyName) => {
      const userdata ={
        EmailAddress : email,
        Password : password,
        Name : name,
        Role : "user"
      }
      register(userdata)
      .then((response) => {
        if (response.status === "ok") {
          localStorage.setItem("token", response.token)
          setIsLoggedIn(true); // Set logged in to true
         // setIsLoggedIn(false); // Automatically log in after registration
        }else{
          Swal.fire({
            title: 'Somthinge wa wrong',
            text: 'Invalid email or password',
            icon: 'error',
            confirmButtonText: 'Ops',
          });
        }
       
      })
    };

  return (
    <div className="App" dir={currentLanguage === "fa" ? "rtl" : "ltr"}>
      {!isLoggedIn ? (
        // Show login or register page if not logged in
        isRegistering ? (
          <Register
            translate={translate}
            handleRegister={handleRegister}
            switchToLogin={() => setIsRegistering(false)}
          />
        ) : (
          <Login
            translate={translate}
            handleLogin={handleLogin}
            switchToRegister={() => setIsRegistering(true)}
          />
        )
      ) : (
        // Show main app if logged in
        <>
          <button className="language-toggle" onClick={toggleLanguage}>
            {currentLanguage === "en" ? "FA" : "EN"}
          </button>
          <button className="logout-button" onClick={handleLogout}>
            {translate("logout")}
          </button>
          <div className="logo">
            <img src="image/logo.png" alt="Logo" width="150" />
          </div>
          <div className="container">
            <div className="tabs">
              <div
                className={`tab ${activeTab === "myApp" ? "active" : ""}`}
                onClick={() => setActiveTab("myApp")}
              >
                {translate("myApp")}
              </div>
              <div
                className={`tab ${activeTab === "deploy" ? "active" : ""}`}
                onClick={() => setActiveTab("deploy")}
              >
                {translate("deploy")}
              </div>
              <div
                className={`tab ${activeTab === "panels" ? "active" : ""}`}
                onClick={() => setActiveTab("panels")}
              >
                {translate("panels")}
              </div>
              <div
                className={`tab ${activeTab === "billing" ? "active" : ""}`}
                onClick={() => setActiveTab("billing")}
              >
                {translate("billing")}
              </div>
              <div
                className={`tab ${activeTab === "profile" ? "active" : ""}`}
                onClick={() => setActiveTab("profile")}
              >
                {translate("profile")}
              </div>
            </div>

            {activeTab === "myApp" && <MyApp translate={translate} />}
            {activeTab === "deploy" && <Deploy translate={translate} />}
            {activeTab === "panels" && <Panels translate={translate} />}
            {activeTab === "billing" && <Billing translate={translate} />}
            {activeTab === "profile" && <Profile translate={translate} />}
          </div>
        </>

      )}
    </div>
  );
}

// Login Component
const Login = ({ translate, handleLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    handleLogin(email, password); // Pass email and password to handleLogin
  };

  return (
    <div className="login-container">
      <h2>{translate("login")}</h2>
      <form onSubmit={onSubmit}>
        <div>
          <label>{translate("emailAddress")}</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label>{translate("password")}</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">{translate("login")}</button>
      </form>
    </div>
  );
};

// Register Component
const Register = ({ translate, handleRegister, switchToLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [familyName, setFamilyName] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    handleRegister(email, password, name, familyName);
  };

  return (
    <div className="login-container">
      <h2>{translate("register")}</h2>
      <form onSubmit={onSubmit}>
        <div>
          <label>{translate("name")}</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div>
          <label>{translate("familyName")}</label>
          <input
            type="text"
            value={familyName}
            onChange={(e) => setFamilyName(e.target.value)}
            required
          />
        </div>
        <div>
          <label>{translate("email")}</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label>{translate("password")}</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">{translate("register")}</button>
      </form>
      <div className="register-link">
        <span>{translate("haveAccount")} </span>
        <a href="#" onClick={switchToLogin}>
          {translate("loginHere")}
        </a>
      </div>
      <div><a href="https://www.darmant.com/policy">قوانین سایت</a></div>
    </div>
  );
};

export default App;